import { authorizationAxios } from "axios/authorizationAxios";
import { BASE_URL } from "constants/BASE_URL";
import { useQuery, useMutation } from "react-query";

export const usePostInvoiceExtra = () => {
  async function postInvoiceExtra(values) {
    const res = await authorizationAxios.post(
      `${BASE_URL}/api/heli-partners/invoice-extra/`,
      values
    );
    return res;
  }

  const postInvoiceExtraMutation = useMutation(postInvoiceExtra);

  return {
    postInvoiceExtraMutation,
  };
};
